declare var require: any;

require('isomorphic-fetch');

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Config } from '@mitel/cloudlink-sdk';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Config.appInfo = environment.appInfo;

const isStage = window.location.href.indexOf('accounts-stage.') > 0;
if (isStage) {
  // We are on a stage deployment, eg accounts-stage.{dev.}mitel.io,
  // We want to point environment callCentreBaseURL variable to cc-admin-stage.
  // This is so that when new cc-admin code is deployed to -stage, we can test it's
  // accounts-app micro-front-end integration via via accounts-stage.{dev.}mitel.io.
  environment.callCenterSpa.callCentreBaseURL = environment.callCenterSpa.callCentreBaseURL.replace(
    'cc-admin.',
    'cc-admin-stage.'
  );
}


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
.then(() => {
  // HACK: https://github.com/angular/angular-cli/issues/13351
  // -> angular broke service worker registration
  const enableServerWorker =  (environment.production ||
    window.location.href.indexOf('.dev.mitel.io') > 0 ) 
    ? true
    : false;
  if ('serviceWorker' in navigator && enableServerWorker ) {
    console.log('Registering service worker');
    navigator.serviceWorker.register('./global-worker.js');
  }
})
.catch(err => console.log(err));
